import { render, staticRenderFns } from "./TestTake.vue?vue&type=template&id=144928b1"
import script from "./TestTake.vue?vue&type=script&lang=ts"
export * from "./TestTake.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports